<template>
    <!-- <nav class="topHeader mb-4 bg-white d-flex justify-content-between align-items-center">
      
         Sidebar Toggle (Topbar) 
        <button id="sidebarToggleTop" class="btn btn-link rounded-circle mx-3">
          <img src="images/collapse.png" alt="collapse">
        </button>
        <div class="page-title">
            <h1>{{pageTxt1}}</h1>
        </div>
        <ul class="loc-items d-flex justify-content-end">
            <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
            <li class="nav-item" v-if="$route.name == 'TestReport'"> <router-link  class=" btn btn-blue Upload-test" to="/upload-test-reports">Upload Lab Test</router-link> </li>
            <li class="nav-item">
                <a class="nav-link d-flex justify-content-center align-items-center" href="#"><i class="icon icon-bell"></i></a>
            </li>
            <li class="nav-item position-relative">
                <a class="nav-link d-flex justify-content-center align-items-center dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" href="javascript:void(0)">Hello Punit <i class="icon icon-user"></i></a>
                <div class="dropdown-menu p-0" aria-labelledby="dropdownMenuButton">
                    <a class="dropdown-item" href="#" @click="$parent.logout()">Log Out</a>
                </div>
            </li>
        </ul>
    </nav> -->
     <div class="topHeader bg-white d-flex justify-content-between align-items-center">
        <div class="sidebar-brand" > 
            <router-link class="moblogo d-none" to="/get-started"><!-- /dashboard -->
                <img src="../../../../static/website/images/logo.svg" class="logo" alt="logo">
            </router-link>
            <div class="page-title">
                <h6 class="themecolor m-0">{{pageTxt1}} </h6>
                <p class="m-0 medium glight" v-if="$route.name == 'dashboard'">Welcome back, {{ get_user.profile.firstname || ''}} {{(get_user.profile.lastname)? get_user.profile.lastname :''}}</p>
            </div>
        </div>
        <div class="rightHeaderMenu d-flex align-items-center">
            <ul class="loc-items d-flex justify-content-end">
                <!-- <li class="nav-item dropdown"> -->
                <!-- <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true"> -->
                <li class="nav-item">
                    <a class="nav-link d-flex justify-content-center align-items-center" href="#"><i class="icon icon-bell"></i></a>
                </li>
                <li class="nav-item position-relative">
                    <span class="nav-link d-flex justify-content-center align-items-center" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Hello {{ get_user.profile.firstname ||''}} <i class="icon icon-user"></i></span>
                     <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                        <router-link class="dropdown-item" to="/profile" >Profile</router-link>
                        <router-link class="dropdown-item" to="change-password" >Change Password</router-link>
                        <a class="dropdown-item" href="javascript:void(0)" @click="$parent.logout()">Log Out</a>
                    </div>
                </li>
            </ul>
            <button class="d-none navbar-toggler" type="button" data-toggle="collapse" data-target="#exCollapsingNavbar" aria-controls="exCollapsingNavbar" aria-expanded="false" aria-label="Toggle navigation">
                <!--just add these span here-->
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <!--/end span-->
            </button>
        </div> 
        </div> 
</template>
<script>
    import * as types from "@/types";
    import { mapActions } from "vuex";
    export default {
        name: "app-header",
        props: ["pageTxt1"],
        data() {
            return {
                
            };
        },
        mounted() {
            $(function() {
              //toggle class open on button
              $('#exCollapsingNavbar').on('hide.bs.collapse', function () {
                $('.navbar-toggler').removeClass('open');
              })
              $('#exCollapsingNavbar').on('show.bs.collapse', function () {
                $('.navbar-toggler').addClass('open');
              })
            });
        },
        
    };
</script>



// WEBPACK FOOTER //
// src/components/website/shared/header.vue